import React, { createContext, useState, useContext, ReactNode } from "react";
import { User } from "../models/user";
import { Workspace } from "../models/workspace";

export interface AuthState {
  workspace: Workspace | null;
  user: User | null;
  loading?: boolean;
  accessToken?: string | null;
}

interface AuthContextType extends AuthState {
  auth: AuthState;
  setAuth: React.Dispatch<React.SetStateAction<AuthState>>;
}

const AuthContext = createContext<AuthContextType | null>(null);

export const AuthProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [auth, setAuth] = useState<AuthState>({
    user: null,
    loading: true,
    accessToken: null,
    workspace: null,
  });

  return <AuthContext.Provider value={{ ...auth, auth, setAuth }}>{children}</AuthContext.Provider>;
};

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error("useAuth must be used within an AuthProvider");
  }
  return context;
};
